const sectionCookiesBar = document.getElementById('cookies_bar_section');
const sectionCookiesBarButton = document.getElementById('btn_cookies_entendi');

function closeCookieTerms() {
	if (sectionCookiesBar) {
		sectionCookiesBar.remove();
	}
}
policyTerms.on('accept', () => {
	closeCookieTerms();
});

if (policyTerms.getPolicyTermIsAccepted()) {
	closeCookieTerms();
}

if (sectionCookiesBar) {
	sectionCookiesBarButton.addEventListener('click', () => {
		policyTerms.setPolicyTermAsAccepted();
	});
}

// not remove ths funcion
// this is usable on contactButtonV2
function getHeightFromCookieBar() {
	const bar = document.getElementById('cookies_bar_section')
	return bar.clientHeight;
}

